var _circle, _path, _g, _path2, _g2, _path3, _path4, _g3, _path5, _path6, _g4, _path7, _path8, _g5, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilBroken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 78.9474,
    fill: "#FAFBFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4181_29178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 68,
    width: 83,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.142 84.7165L111.727 89.0582L102.632 94.6542L105.696 99.2853L100.334 105.364L32.3755 89.5112L29.7745 84.7165L34.2743 82.7868L31.1149 77.9627L36.1891 74.9717L32.6467 71.016L37.5294 68.3145L109.142 84.7165Z",
    fill: "#C87F3B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4181_29178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.6 99.2856L34.274 82.7871H29.1998L27.285 91.6635L104.547 107.294L105.6 99.2856Z",
    fill: "#9DA5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.709 91.8554L36.3829 75.3569L31.6658 73.0176L29.5312 78.3957L34.5121 83.0567L106.177 99.381L107.709 91.8554Z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.79 85.0113L37.7721 67.2539H32.293L31.8795 74.4192L113.135 93.1112L114.79 85.0113Z",
    fill: "#EEF0F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4181_29178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 65,
    width: 89,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.686 86.164L194.83 65.1309L200 86.6465L113.931 108.355L116.324 100.636L111.441 97.6455L116.898 88.6726L112.686 86.164Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4181_29178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.534 85.1627L198.082 63.2012L201.529 64.0695L203.827 76.2202L112.775 94.558L111.534 85.1627Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.108 92.9791L198.657 71.0176L202.103 71.8859L204.401 84.0366L113.349 102.374L112.108 92.9791Z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.493 101.083L199.903 78.832L202.488 79.9898L204.785 92.1405L113.734 110.478L112.493 101.083Z",
    fill: "#9DA5B1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.556 115.785L99.0879 119.258L106.556 107.873V115.785Z",
    fill: "#EEF0F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4181_29178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 107,
    width: 8,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.556 115.785L99.0879 119.258L106.556 107.873V115.785Z",
    fill: "#AFD0FE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4181_29178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.9571,
    y: 106.004,
    width: 11.2972,
    height: 7.1397,
    fill: "#9DA5B1"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.899 132.089L115.366 135.563L107.899 124.178V132.089Z",
    fill: "#EEF0F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4181_29178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 124,
    width: 9,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.899 132.089L115.366 135.563L107.899 124.178V132.089Z",
    fill: "#AFD0FE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4181_29178)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2972,
    height: 7.1397,
    transform: "matrix(-1 0 0 1 115.234 122.309)",
    fill: "#9DA5B1"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.293 140.001L96.2192 149.746L100.24 131.896L101.293 140.001Z",
    fill: "#EEF0F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4181_29178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 131,
    width: 6,
    height: 19
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.293 140.001L96.2192 149.746L100.24 131.896L101.293 140.001Z",
    fill: "#AFD0FE"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4181_29178)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2972,
    height: 7.13971,
    transform: "matrix(-1 0 0 1 104.513 131.379)",
    fill: "#9DA5B1"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6256 68.3145L0.00012207 70.823L32.3758 89.5112L29.8853 84.8502L34.5104 83.0575L31.3084 78.0379L36.6451 75.1696L33.0873 71.2257L37.6256 68.3145Z",
    fill: "#EEF0F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.808 70.2441L8.04209 75.4542L0 70.823L8.808 70.2441Z",
    fill: "#9DA5B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilBroken);
export default __webpack_public_path__ + "static/media/pencil-broken.e6fe1b7b.svg";
export { ForwardRef as ReactComponent };